import { PayloadAction, createSlice } from '@reduxjs/toolkit';

interface PaymentState {
	isLoading: boolean;
	paymentList: any[];
	totalPayment: number;
}

const initialState: PaymentState = {
	isLoading: false,
	paymentList: [],
	totalPayment: 0
};

const paymentSlice = createSlice({
	name: 'payment',
	initialState,
	reducers: {
		getAllPaymentListInIt: state => {
			state.isLoading = true;
		},
		getAllPaymentListSuccess: (state, action: PayloadAction<any>) => {
			const data = action.payload.data;
			state.isLoading = false;
			state.totalPayment = data.totalCount;
			state.paymentList = [...data.deliveredOrders];
		},
		getAllPaymentListError: state => {
			state.isLoading = false;
			state.paymentList = [];
			state.totalPayment = 0;
		},
		updatePaymentStatusInit: state => {
			state.isLoading = true;
		},
		updatePaymentStatusSuccess: state => {
			// Loading will be handled by the subsequent API call
		},
		updatePaymentStatusError: state => {
			state.isLoading = false;
		}
	}
});

export const {
	getAllPaymentListInIt,
	getAllPaymentListSuccess,
	getAllPaymentListError,
	updatePaymentStatusInit,
	updatePaymentStatusSuccess,
	updatePaymentStatusError
} = paymentSlice.actions;

export default paymentSlice.reducer;